
import { defineComponent } from "vue";
import { Saica } from "@/types/saica.type";
import { Filter } from "@/types/filter.type";
import { getSaicas } from "@/service/saica.service";
import ObserverComponent from "../Observer.component.vue";
import { dateFormatDate } from "@/utils/date.utils";

export default defineComponent({
  components: { ObserverComponent },
  props: {},
  data() {
    return {
      items: [] as Saica[],
      query: "" as string,
      currentPage: 1 as number,
      hasMore: true,
    };
  },

  methods: {
    dateFormatDate,
    async showMore() {
      const filter: Filter = {};
      this.hasMore = false;
      const rowPerPage = 10;
      if (this.query) {
        filter.multi = this.query;
      }

      const { data, totalRows } = await getSaicas(this.currentPage, rowPerPage, filter);

      // - concat result array
      this.items = [...this.items, ...data];

      // - check if exist more result
      this.hasMore = totalRows > this.currentPage * rowPerPage;
      this.currentPage++;
    },

    async refreshItems(item: Saica | undefined = undefined) {
      let index = -1;
      if (this.items && item) {
        index = this.items.findIndex((i) => i.id === item.id);
      }
      if (index !== -1 && item) {
        this.items[index] = item;
      } else {
        this.items = [];
        this.currentPage = 1;
        await this.showMore();
      }
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getMagnitude(info: any) {
      const jsonSaica = JSON.parse(info);
      return [jsonSaica.magnitude, jsonSaica.value, jsonSaica.unit];
    },
  },
});
